import { InjectionToken, Injectable } from '@angular/core';

@Injectable()
export abstract class KanbanEventApiConfig{
        baseUrl:string;
}
export let KANBAN_EVENT_CONFIG = new InjectionToken<KanbanEventApiConfig>('daedelusEventApiConfig');